import { render, staticRenderFns } from "./AddVideo.modal.vue?vue&type=template&id=2767e32c&scoped=true&"
import script from "./AddVideo.modal.vue?vue&type=script&lang=js&"
export * from "./AddVideo.modal.vue?vue&type=script&lang=js&"
import style0 from "./AddVideo.modal.vue?vue&type=style&index=0&id=2767e32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767e32c",
  null
  
)

export default component.exports